<!-- Call Center -->
@if (hasCallCenter) {
  <portal-end-user-call-center-sub-nav></portal-end-user-call-center-sub-nav>
}

<!-- Phone Book -->
@if (isNotResidentialUser) {
  <portal-end-user-phone-book-sub-nav></portal-end-user-phone-book-sub-nav>
}
